import { Form } from "react-bootstrap";
import { useAdminLayoutContext } from "../../views/admin/AdminLayoutContext";
import { LANGUAGES } from "../../core/consts";
import { MilestoneItem } from "../../views/admin/grandsprix/UpdateGPResults";

interface MilestonesProps {
  // Ahora permitimos que pueda ser undefined por si aún no han cargado los datos
  milestones?: Record<string, MilestoneItem[]>;
  inputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
}

const Milestones = ({ milestones, inputChange }: MilestonesProps) => {
  const { setActiveMenu, setActiveSubItem } = useAdminLayoutContext();

  return (
    <>
      {LANGUAGES.map((language) => {
        // Obtenemos los ítems de este idioma de forma segura
        const langMilestones = milestones?.[language.code] || [];

        // Convertimos el array de objetos a un string con saltos de línea para el textarea
        const textValue = langMilestones
          .map((item) => item.description || "")
          .join("\n");

        return (
          <Form.Group className="form-group" key={language.code}>
            <Form.Label>Milestones [{language.code}]</Form.Label>
            <Form.Control
              as="textarea"
              name={`milestones_${language.code}`}
              onChange={inputChange}
              value={textValue}
            />
          </Form.Group>
        );
      })}
    </>
  );
};

export default Milestones;
